<template>
  <div>
      <HeaderComponent :brand-word="brand"/>
      <ContactUs
          :brand="brand"
          :logo="logo"
          :brand-header="brandHeader"
          :models-data="modelsData"
          :dealers-data="dealersData"
          :client-id="clientId"
          calculator-component="peugeot-finance-calculator"
      />
      <FooterComponent :brand-word="brand"/>
  </div>
</template>

<script>
import { defineComponent, onMounted, reactive } from 'vue'
import HeaderComponent from './HeaderComponent.vue'
import ContactUs from './ContactUs.vue'
import FooterComponent from './FooterComponent.vue'
import CONSTANTS from '../data/constants'
import loadedModelsData from '../data/models_data_peugeot.json'
import dealersData from '../data/dealers_data_peugeot'

export default defineComponent({
name: 'PeugeotContactUs',
components: {
  HeaderComponent,
  FooterComponent,
  ContactUs
},
setup () {
  const brand = CONSTANTS.BRANDS.PEUGEOT
  const clientId = process.env.VUE_APP_PEUGEOT_CLIENT_ID

  const logo = '/img/peugeot-logo.png'
  const brandHeader = '/img/peugeot-title.png'
  const modelsData = reactive(loadedModelsData)

  const init = () => {
    document.getElementById('favicon').href = '../favicon.ico'
    document.getElementById('page_title').text = 'Peugeot - iOWN'
    document.documentElement.style.setProperty('--button-accent', '#00a3e0')
    document.documentElement.style.setProperty('--button-color', '#ffffff')
    document.documentElement.style.setProperty('--header-line-bg', '#e6f6fc')
    document.documentElement.style.setProperty('--tooltip-accent', '#00a3e0')
    document.documentElement.style.setProperty('--font', "'Lato', sans-serif")
  }

  onMounted(() => {
    init()
  })
  return {
      brand,
      logo,
      brandHeader,
      modelsData,
      clientId,
      dealersData
  }
}
})
</script>
